<div *ngIf="listSize > PAGE_SIZE && paginationRefresh" class="pagination-container">
    <c11n-pagination [variant]="'unNumbered'" [firstAndLastOption]="'caretLink'" [itemsPerPage]="PAGE_SIZE"
        [totalNumberOfItems]="listSize"
        descriptiveLabel="{{(page - 1)*PAGE_SIZE + 1}}-{{(page*PAGE_SIZE < listSize) ? (page*PAGE_SIZE) : listSize}} of {{listSize}}"
        [hasFirstAndLastPages]="true" [hideControlsWithNoResults]="true" [firstAriaLabel]="'Go to first page'"
        [lastAriaLabel]="'Go to last page'" (activeItemChange)="changePage($event);">
    </c11n-pagination>
</div>